import React from "react";

export const ButtonComponent = (props) => {
  return <button {...props.data}>{props.children}</button>;
};
